import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSession } from "../contexts/SessionContext";
import { CsrAPI } from "../apis/CsrAPI";
import { setSentryUser } from "../utils/Sentry";

export const LoginCallbackHandler = ({ children }) => {
  const { setSessionReady, setLoginForbidden } = useSession();
  const { isAuthenticated, user } = useAuth0();

  React.useEffect(() => {
    const handleLogin = async () => {
      if (isAuthenticated) {
        setSessionReady(false);
        setSentryUser(user);
        try {
          await CsrAPI.login();
        } catch (error) {
          // A 403 means the backend refuses this user, so LoginForbiddenGate
          // moves them to the access-denied page. Any other failure is already
          // logged by the axios interceptor, and leaving the session unready
          // keeps the app on its loader rather than on half-loaded pages.
          if (error?.response?.status === 403) {
            setLoginForbidden(true);
          }
          return;
        }
        setLoginForbidden(false);
        setSessionReady(true);
      }
    };

    handleLogin();
  }, [isAuthenticated, setSessionReady, setLoginForbidden, user]);

  return children;
};
